// extracted by mini-css-extract-plugin
export default {"button":"styles_button__SU0gi","spinner":"styles_spinner__WngaB"};